<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                New Storefront
            </h1>

            <card-box>
                <card-title>Details</card-title>
                <div class="form-group mt-3">
                    <label><strong>Name</strong></label>
                    <input-edit v-model="name" />
                </div>

                <div class="form-group mt-3">
                    <label><strong>URL path</strong></label>
                    <input-edit v-model="slug" @change="changeSlug('slug',$event)" />
                </div>

                <div class="form-group mt-3">
                    <toggle-button v-model="isolate" :sync="true" />
                    Hide storefront page from search engines
                </div>
            </card-box>

            <div class="card-box">
                <button v-if="banner != '' && changeBanner == false" class="btn btn-danger float-right btn-sm"
                        @click="removeBanner()">
                    Remove
                </button>
                <card-title>Banner</card-title>
                <div class="mt-3">
                    <vue-dropzone v-if="banner == '' || changeBanner == true" id="bannerFile" ref="vueDropzone"
                                  :options="dropBannerOptions" :use-custom-slot="true"
                                  @vdropzone-removed-file="bannerFile=''; changeBanner = false" @vdropzone-success="bannerDone">
                        <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title">
                                Banner
                            </h3>
                            <div class="subtitle">
                                Drag and drop png file. <br> (Recommended size: Min width
                                1500px /
                                Height 300px)
                            </div>
                        </div>
                    </vue-dropzone>

                    <img v-if="banner != '' && changeBanner == false" class="img-thumbnail" :src="bannerFile" alt=""
                         @click="changeBanner = true">
                </div>
            </div>

            <card-box>

                <card-title>Description</card-title>
                <editor :init="customToolbar"
                        api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                        v-model="detail"></editor>
            </card-box>

            <card-box>
                <div class="float-right toggle-custom">
                    <toggle-button
                            v-model="auto"
                            :width="70"
                            :labels="{checked: 'Tag', unchecked: 'Manual'}"
                            :height="26"
                            :margin="0"
                            :padding="0"
                            :sync="true"
                    />
                </div>
                <card-title>Campaign</card-title>
                <div
                        v-if="auto == true"
                        class="form-group mt-3"
                >
                    <label>Add campaigns using tags</label>

                    <vue-tags-input
                            v-model="tag"
                            :tags="tags"
                            @tags-changed="newTags => tags = newTags"
                    />
                    <small
                            id="emailHelp"
                            class="form-text text-muted"
                    >This enables you to automatically add all
                        campaigns with a specified tag.
                    </small>
                </div>


                <campain-modal
                        v-if="auto == false"
                        :data="data"
                        @choiced="choiced"
                        @removed="removed"
                />
            </card-box>

            <card-box>
                <toggle-button
                        v-model="status"
                        :height="24"
                        :margin="1"
                        :sync="true"
                />
                {{ statusText }}
            </card-box>


            <card-box>
                <div>
                    <button
                            class="btn btn-block btn-success"
                            @click="save"
                    >
                        Save
                    </button>
                </div>
            </card-box>
        </div>
    </div>
</template>

<script>
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import vue2Dropzone from 'vue2-dropzone'
    import CardBox from "@/components/CardBox";
    import CardTitle from "@/components/CardTitle";
    import InputEdit from "@/components/InputEdit";

    import Editor from '@tinymce/tinymce-vue';

    import VueTagsInput from "@johmun/vue-tags-input";
    import CampainModal from "@/components/CampainModal";

    export default {
        name: "EditCollection",
        components: {
            CampainModal,
            InputEdit,
            CardTitle,
            CardBox,
            VueTagsInput,
            Editor,
            VueDropzone: vue2Dropzone
        },
        data: function () {
            return {
                customToolbar: { height: 500,
                    menubar: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic forecolor  backcolor image  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat code '},
                dropBannerOptions: {
                    url: this.$config.api + 'collection/banner',
                    thumbnailWidth: 400,
                    addRemoveLinks: true,
                    headers: {
                        'Authorization': this.$http.defaults.headers.common['Authorization']
                    }
                },
                data: [],
                changeBanner: false,
                banner: '',
                name: '',
                slug: '',
                tag: '',
                tags: [],
                status: false,
                detail: '',
                auto: false,
                isolate: false,
                id: '',
                lock: false,

            }
        },
        computed: {
            bannerFile: function () {
                return this.$config.images + this.banner
            },
            statusText: function () {
                return this.status ? 'Storefront is open' : 'Storefront is close'
            }

        },
        mounted: function () {
            this.id = this.$route.params.id
            this.$refs.vueDropzone.setOption('url', this.$config.api + 'collection/banner/' + this.id);

            this.load()
        },
        methods: {
            removeBanner: function () {
                this.$http.post(this.$config.api + 'collection/banner/' + this.id + '?remove=1')
                this.banner = ''
            },
            changeHtmlMode: function () {
                this.htmlMode = this.htmlMode == true ? false : true
            },
            changeSlug: function (val) {
                let vm = this
                if (val == '') {
                    this.$swal('Please enter slug')
                    return false
                }
                this.$http.post(this.$config.api + 'collection/slug', {
                    id: this.id,
                    slug: this.slug
                }).then(function (res) {
                    if (res.data.code && res.data.code == 1) {
                        vm.$swal('Slug exists')
                    }
                })
            },
            bannerDone: function () {
            },
            create: function () {
                let vm = this
                vm.loc = true
                this.$http.post(this.$config.api + 'collection/create').then(function (res) {
                    vm.$router.push({ name: 'collection/', 'params': { id: res.data.id } })
                })
            },

            load: function () {
                let vm = this

                this.$http.get(this.$config.api + 'collection/' + vm.id).then(function (res) {
                    let collection = res.data
                    vm.name = collection.name
                    vm.auto = collection.auto == 1 ? true : false
                    vm.data = collection.home_ids == null ? [] : collection.home_ids
                    vm.slug = collection.slug == null ? '' : collection.slug
                    vm.banner = collection.thumb == null ? '' : collection.thumb
                    vm.status = parseInt(collection.status) == 1 ? true : false
                    vm.detail = collection.detail
                    vm.isolate = collection.block_search == 1 ? true : false
                    collection.auto_keyword = collection.auto_keyword || ''
                    collection.auto_keyword = collection.auto_keyword.split(',')
                    for (let i = 0; i < collection.auto_keyword.length; i++) {
                        vm.tags.push({ text: collection.auto_keyword[i] })
                    }
                })
            },

            choiced: function (e) {
                let vm = this
                this.$http.get(this.$config.api + 'collection/' + vm.id + '/choice/' + e)
            },
            removed: function (e) {
                let vm = this
                this.$http.delete(this.$config.api + 'collection/' + vm.id + '/choice/' + e)
            },
            save: function () {
                if (this.name == '') {
                    this.$swal('Please enter name')
                }
                if (this.slug == '') {
                    this.$swal('Please enter url')
                }
                let post = {
                    id: this.id,
                    name: this.name,
                    detail: this.detail,
                    slug: this.slug,
                    auto: this.auto,
                    status: this.status,
                    block_search: this.isolate,
                    auto_keyword: []
                }
                for (let i = 0; i < this.tags.length; i++) {
                    post.auto_keyword.push(this.tags[i].text)
                }

                let vm = this

                this.$http.post(this.$config.api + 'collection', post).then(function () {
                    vm.$router.push({ name: 'store' })
                })


            },
        }
    }

</script>

<style lang="scss" scoped>
    .toggle-custom {
        padding: 0px;

        label {
            padding: 0;
            margin: 0;

        }
    }
</style>